import { CarIcon, HandshakeIcon, RocketIcon, TaskIcon } from '@autoplan/web-ui'
import { TaskCard } from './Cards/TaskCard'
import { useNavigate } from 'react-router-dom'

export const TaskCardRow = () => {
  const navigate = useNavigate()
  return (
    <div className="ap:overflow-x-auto ap:-ml-3xl ap:-mr-2xl ap:px-2xl ap:py-xl ap:-my-xl ap:snap-x ap:snap-mandatory ap:scroll-px-xl ap:[scrollbar-width:none] ap:[&::-webkit-scrollbar]:hidden">
      <div className="ap:flex ap:flex-row ap:items-stretch ap:gap-xl">
        <TaskCard
          icon={<RocketIcon />}
          title="Overkjørte km"
          subtitle="5 biler har kjørt over i henhold til kontrakt"
          priority="high"
          onClick={() => navigate('/')}
        />
        <TaskCard
          icon={<TaskIcon />}
          title="48 Uavklarte biler"
          subtitle="Rebestill eller lever inn biler"
          priority="high"
          onClick={() => navigate('/')}
        />
        <TaskCard
          icon={<CarIcon />}
          title="21 Utgående biler"
          subtitle={
            <>
              Utløper de neste <strong>6 mnd</strong>
            </>
          }
          priority="medium"
          onClick={() => navigate('/')}
        />
        <TaskCard
          icon={<HandshakeIcon />}
          title="Registrere biler"
          subtitle={
            <>
              <strong>12 biler</strong> må registreres
            </>
          }
          priority="low"
          onClick={() => navigate('/')}
        />
        <div className="ap:min-w-xl ap:shrink-0" />
      </div>
    </div>
  )
}
